import script from "./VacancyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancyDetail.vue?vue&type=script&setup=true&lang=js"

import "./VacancyDetail.vue?vue&type=style&index=0&id=1f3d5032&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f3d5032"]])

export default __exports__